import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import { clinicTypes, routes } from '../../../consts'
import $t from '../../../i18n'
import BotPreviewTemplate from '../../common/BotPreviewTemplate'

import './DmBotPreview.css'

const DmBotPreview = () => {
  const dispatch = useDispatch()

  const onExit = () => {
    dispatch(Actions.createAction(Actions.PRIMARY_CLINIC_CLICKED))
    dispatch(Actions.createAction(Actions.SEE_A_DOCTOR_CLICKED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: 'dm_bot_terminated_primary',
      })
    )
  }

  const onStart = () => {
    dispatch(Actions.createAction(Actions.DIABETES_BOT_INITED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: 'dm_bot_started',
      })
    )
  }

  const renderTitle = () => {
    return (
      <h1 className="bot-preview-title">
        {$t('pages.getStarted.dmBotPreview.welcome')}
        <br />
        {$t('pages.getStarted.dmBotPreview.diabetes')}
        <br />
        {$t('pages.getStarted.dmBotPreview.specialtyCareService')}
      </h1>
    )
  }

  const actions = [
    {
      title: $t('pages.getStarted.dmBotPreview.primary'),
      type: 'outlined',
      handleOnClick: onExit,
    },
    {
      title: $t('pages.getStarted.dmBotPreview.continue'),
      handleOnClick: onStart,
    },
  ]

  return (
    <BotPreviewTemplate
      key={1}
      clinic={clinicTypes.DIABETES}
      actions={actions}
      contentTitle={renderTitle()}
      contentPoints={[
        $t('pages.getStarted.dmBotPreview.bullets.descriptionPoint1'),
        $t('pages.getStarted.dmBotPreview.bullets.descriptionPoint2'),
        $t('pages.getStarted.dmBotPreview.bullets.descriptionPoint3'),
      ]}
    />
  )
}

export default DmBotPreview
